<template>

  <div>
    <header id="blog-header">
      <div class="inner ">
        <nav id="navigation">
          <span class="blog-logo">
          </span>
        </nav>
      </div>
    </header>

    <article class="post">
    <div class="inner">
      <p class="meta">
        <time :pubdate="blogpost.fields.pub_date" >{{$options.filters.date(blogpost.fields.pub_date, '%w')| toWeekDay}},</time>
        <time :pubdate="blogpost.fields.pub_date" :data-updated="blogpost.fields.last_edit_date"
              v-text="$options.filters.date(blogpost.fields.pub_date, '%b')+' '+
              $options.filters.date(blogpost.fields.pub_date, '%d')+ ','+
              $options.filters.date(blogpost.fields.pub_date, '%Y') + ' at '+
              $options.filters.date(blogpost.fields.pub_date, '%T')"
        >
        </time>
      </p>

      <header class="post-header">
        <h2 class="post-title">生日快乐</h2>
        <div class="clear"></div>
      </header>
      	<audio autoplay="autoplay" loop="loop" preload="auto" ><source src="https://music.163.com/song/media/outer/url?id=5093684.mp3" type="audio/mpeg"></audio>
      <div class="post-excerpt">
            <span v-html="blogpost.content"></span>
      </div>
      <footer class="post-meta">
        <img class="author-thumb" src="../assets/images/ccx_2.jpeg" alt="Changxin Cheng" nopin="nopin" />
        <router-link :to="{ name: 'profile'}">Changxin Cheng</router-link>
        posted in
        <tag-item
         v-for="tag in blogpost.tags"
         v-bind:key = "tag.pk"
         v-bind:tag = "tag"
        />
        <time class="post-date" :pubdate="blogpost.fields.pub_date" :data-updated="blogpost.fields.last_edit_date" v-text="$options.filters.date(blogpost.fields.pub_date, '%b') +' '+$options.filters.date(blogpost.fields.pub_date, '%d')+ ','+ $options.filters.date(blogpost.fields.pub_date, '%Y') ">
        </time>
      </footer>
    </div>
  </article>
  </div>
</template>

<script>
import tagItem from './TagItem'
export default {
  name: 'digtal-album',
  components: {
    tagItem,
    'remote-js': {
      render(createElement) {
        return createElement('script', { attrs: { type: 'text/javascript', src: this.src }});
      },
      props: {
        src: { type: String, required: true },
      },
    }
  },
  data() {
    return {
      blogpost: null
    }
  },
  computed: {},
  beforeCreate() {

  },
  created() {
    this.getBlogPost()
  },
  mounted() {
    this.$nextTick(function () {
    });
  },
  methods: {
    async getBlogPost() {
      let url = '/blog/api/digital-album'
      let reqUrl = this.$store.state.baseUrl + url
      console.log(reqUrl)
      let self = this
      await this.$http.get(reqUrl)
        .then((response) => {
            var res = JSON.parse(response.bodyText)
                  self.blogpost = res.blogpost;
                  console.log(self.blogpost)
        })
    },
  }
}
</script>

<style scoped>

/*最外层容器样式*/

.photo_cube{
  position: relative;
  margin: auto;
}
.wrap{
	position: relative;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 200px;
	height: 200px;
	margin: auto;
	/*改变左右上下,图片方块移动*/

}
/*包裹所有容器样式*/
.cube{
	width: 200px;
	height: 200px;
	margin: 0 auto;
	transform-style: preserve-3d;
	transform: rotateX(-30deg) rotateY(-80deg);
	-webkit-animation: rotate 20s infinite;
	/*匀速*/
	animation-timing-function: linear;
}
@-webkit-keyframes rotate{
	from{transform: rotateX(0deg) rotateY(0deg);}
	to{transform: rotateX(360deg) rotateY(360deg);}
}
.cube div{
	position: absolute;
	width: 200px;
	height: 200px;
	opacity: 0.8;
	transition: all .4s;
}
/*定义所有图片样式*/
.pic{
	width: 200px;
	height: 200px;
}
.cube .out_front{
	transform: rotateY(0deg) translateZ(100px);
}
.cube .out_back{
	transform: translateZ(-100px) rotateY(180deg);
}
.cube .out_left{
	transform: rotateY(90deg) translateZ(100px);
}
.cube .out_right{
	transform: rotateY(-90deg) translateZ(100px);
}
.cube .out_top{
	transform: rotateX(90deg) translateZ(100px);
}
.cube .out_bottom{
	transform: rotateX(-90deg) translateZ(100px);
}
/*定义小正方体样式*/
.cube span{
	display: block;
	width: 100px;
	height: 100px;
	position: absolute;
	top: 50px;
	left: 50px;
}
.cube .in_pic{
	width: 100px;
	height: 100px;
}
.cube .in_front{
	transform: rotateY(0deg) translateZ(50px);
}
.cube .in_back{
	transform: translateZ(-50px) rotateY(180deg);
}
.cube .in_left{
	transform: rotateY(90deg) translateZ(50px);
}
.cube .in_right{
	transform: rotateY(-90deg) translateZ(50px);
}
.cube .in_top{
	transform: rotateX(90deg) translateZ(50px);
}
.cube .in_bottom{
	transform: rotateX(-90deg) translateZ(50px);
}
/*鼠标移入后样式*/
.cube:hover .out_front{
	transform: rotateY(0deg) translateZ(200px);
}
.cube:hover .out_back{
	transform: translateZ(-200px) rotateY(180deg);
}
.cube:hover .out_left{
	transform: rotateY(90deg) translateZ(200px);
}
.cube:hover .out_right{
	transform: rotateY(-90deg) translateZ(200px);
}
.cube:hover .out_top{
	transform: rotateX(90deg) translateZ(200px);
}
.cube:hover .out_bottom{
	transform: rotateX(-90deg) translateZ(200px);
}


/**
  界面基础信息展示
 */
.codehilite code, tt {
  position: relative;
  margin: 0 0.334em;
  padding: 0.334em 0.667em;
  font-family: monospace, sans-serif;
  font-size: 1.2em;
  white-space: pre;
  background: #faf9f7;
  border: 1px solid #e5e4e1;
  top: -2px
}

.author-thumb {
  width: 24px;
  height: 24px;
  float: left;
  margin: auto;
  padding: 3px;
  border-radius: 100%;
  margin-top: -5px;
}

.post-date {
  display: inline-block;
  margin-left: 8px;
  padding-left: 12px;
  border-left: #d5dbde 1px solid;
  text-transform: uppercase;
  font-size: 1.3rem;
  white-space: nowrap;
}

.post-title h2 {
  font-size: 2.0em;
}

.post-excerpt {
  font-size: 0.8em;
}

.container .post {
  padding: 1.5em 0;
}

.post-meta {
  margin: 1.334em 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DigitalAlbum.vue